const mainDomain = "https://api.vasaabacus.com/";
const imageDomain = "https://api.vasaabacus.com";


// const mainDomain = "http://192.168.1.8:9001/";
// const imageDomain = "http://192.168.1.8:9001";

// const mainDomain = "http://10.130.34.124:9001/";
// const imageDomain = "http://10.130.34.124:9001";


const Constant = {
  getUrls: {
    getAllTestimonials: mainDomain + "testimonial",
    getAllBlogs: mainDomain + "blogs/list-web",
    getAllEvents: mainDomain + "event",
    getAllGalleryImages: mainDomain + "gallery",
    getAllCourses: mainDomain + "courses",
    getSocialMedia: mainDomain + "social-media",
    getAllBanners: mainDomain + "banner",
    getAboutUs: mainDomain + "about-us",
    getAllAlumini: mainDomain + "alumini",
    getAllExams: mainDomain + "exams",
    getCountsList: mainDomain + "counts",
    getAllAmenities: mainDomain + "amenities",
    getAllNavbarTexts: mainDomain + "navbartext",
    getAllFaqs: mainDomain + "faqs",
    getAllTeams: mainDomain + "teams",
    getAllSocialMedia: mainDomain + "social-media",
    getAllYoutTubeSlider: mainDomain + "youtube-slider",
    getAbacusSchoolData: mainDomain + "abacus-school",
    getAllAbacusCourses: mainDomain + "abacus-course",
    getAllYoutube: mainDomain + "all-youtube",
  },
  postUrls:{
    submitFranchiseEnquiry: mainDomain + "franchise-enquiry",
    schoolEnquiry: mainDomain + "school-enquiry",
    createDemo: mainDomain + "demos/create",
  }
};

export { Constant, imageDomain };
